import { Trans } from '@lingui/react/macro';
import { FolderOpenIcon } from '@phosphor-icons/react';
import { Typography } from '@remarkable/ark-web';

export const DropAccept = () => {
  return (
    <div
      data-cy="drop-accepted"
      className="flex size-full flex-row items-center justify-center bg-interaction-primary-default-subtle p-32 text-left"
      style={{
        backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%237B61FF' stroke-width='1' stroke-dasharray='8%2c 8' stroke-dashoffset='3' stroke-linecap='butt'/%3e%3c/svg%3e")`,
      }}
    >
      <div className="flex flex-col items-center gap-8 lm:flex-row lm:items-start">
        <FolderOpenIcon size={32} className="mt-4 text-text-muted" />
        <div className="w-4/5 lm:w-auto">
          <Typography variant="body-2xl" className="hidden md:block">
            <Trans>
              Drag and drop or <strong>browse your files</strong>
            </Trans>
          </Typography>

          <Typography variant="body-sm" className="text-center md:text-left">
            <Trans>
              Supports PDF, JPG, PNG, and EPUB files up to {100} MB.
            </Trans>
          </Typography>
        </div>
      </div>
    </div>
  );
};
